import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IngredientsServices } from "../../services";
import { Globals } from "../../../../globals";
import { ProvidersServices } from "../../../providers/services";
import { StaticsServices } from '../../../services/statics';
import { IngredientCompCreatePreparationPage } from "../ingredient-comp-create-preparation/ingredient-comp-create-preparation";
import { TranslateService } from '@ngx-translate/core';
import { StockListPage } from '../../../stock/stock-list/stock-list';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the IngredientCreateStockPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'ingredient-comp-create-stock',
  templateUrl: 'ingredient-comp-create-stock.html',
})
export class IngredientCompCreateStock {

  public form: FormGroup;
  ingredient_name: any;
  ingredient_uid: string;
  update_state: boolean = false;
  value_changes: any;

  show_alert: boolean = true;
  old_stock: number = 0;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientServices: IngredientsServices,
    public fb: FormBuilder,
    public globals: Globals,
    private toastCtrl: ToastController,
    public providersServices: ProvidersServices,
    public staticsServices: StaticsServices,
    public translate: TranslateService,
    private alertCtrl: AlertController,
    private analyticsService: AnalyticsServices) {

    //Params
    this.update_state = this.navParams.get('update_state');
    this.ingredient_name = this.navParams.get('ingredient_name');
    this.ingredient_uid = this.navParams.get('ingredient_uid');

    //Si hacemos update adamptamos la informacion
    if (this.update_state) {
      //this.ingredient_uid = this.navParams.get('ingredient_uid');
      this.old_stock = this.navParams.get('stock');

      var stock_max = 0;
      if (this.navParams.get('stock_max')) {
        stock_max = this.navParams.get('stock_max')
      }

      // Obtener la unidad de medida desde navParams, con 'kg' como valor por defecto si no está disponible
      const measurement = this.navParams.get('measurement') || 'kg';

      this.form = fb.group({
        measurement: [measurement],
        stock: [this.navParams.get('stock')],
        stock_alert: [this.navParams.get('stock_alert')],
        stock_max: [stock_max],
        sub_recipe: [true],
        reason: '',
        reason_desc: '',
      });
    } else {
      // Obtener la unidad de medida desde navParams, con 'kg' como valor por defecto si no está disponible
      const measurement = this.navParams.get('measurement') || 'kg';

      this.form = fb.group({
        measurement: [measurement],
        stock: [0],
        stock_alert: [0],
        stock_max: [0],
        sub_recipe: [true],
        reason: 'new_ingredient',
        reason_desc: '',
      });
    }
  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {
      //Si el show_alert es true i no estem fen un update al plat
      if (this.show_alert && !this.update_state) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('general-salir-proceso-creacion'),
          subTitle: this.translate.instant('general-se-eliminara-elemento'),
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => {
                this.globals.side_menu_active = 'stock';
                reject();
              },
            },
            {
              text: this.translate.instant('general-si'),
              handler: () => {
                this.ingredientServices.afs.collection('ingredients').doc(this.ingredient_uid).delete();
                resolve();
                this.navCtrl.setRoot(StockListPage);
              },
            },
          ],
        });
        alert.present();
      } else {
        resolve();
      }
    });
  }

  submit() {
    if (this.form.valid) {
      this.show_alert = false;
      this.update();
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-introduce-motivo-modificacion'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  update() {
    this.ingredientServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
      'name': this.ingredient_name,
      'measurement': this.form.value.measurement,
      'stock': this.form.value.stock,
      'stock_alert': this.form.value.stock_alert,
      'stock_max': this.form.value.stock_max,
      'sub_recipe': true,
      'updated_user': this.globals.user_name,
      'updated_at': new Date(),
    }).then(() => {
      //send datastore
      this.sendData();
      this.sendDataChangeStock();
      //Enviamos la informacion a collection _data
      this.sendStockAnalytics();
      //
      this.analyticsService.trackingExpStock('modify_stock', this.globals.tracking_exp['modify_stock'], this.ingredient_uid);
      this.globals.GAtrackView('Ingredients', 'Ingredients - Name - Update', this.globals.restaurant.email, 'Create/Update', 'Update name', 'Ingredients', this.ingredient_name);
      if (!this.update_state) { //If update_state false, go to Ingredient Create Allergens Page
        this.navCtrl.push(IngredientCompCreatePreparationPage, {
          update_state: false,
          ingredient_uid: this.ingredient_uid,
          ingredient_name: this.ingredient_name,
          ingredient_measurement: this.form.value.measurement
        });
      } else { //If update_state true
        this.navCtrl.pop();
        this.staticsServices.changeStateStaticWait(true);
      }
    });
  }


  sendData() {
    var extra = {
      "min_stock": this.form.value.stock_alert,
      "max_stock": this.form.value.stock_max,
    };
    this.globals.dataSet('ingredient_name', this.ingredient_name, '', JSON.stringify(extra));
  }

  sendDataChangeStock() {
    var extra = {
      "stock": this.form.value.stock,
      "min_stock": this.form.value.stock_alert,
      "max_stock": this.form.value.stock_max,
      "reason": this.form.value.reason,
      "reason_desc": this.form.value.reason_desc,
    };
    this.globals.dataSet('ingredient_stock', this.ingredient_name, '', JSON.stringify(extra));
  }

  async sendStockAnalytics() {
    let ingredient = await this.ingredientServices.getIngredient(this.ingredient_uid);
    var stock = {
      "elements": [{
        "uid_element": this.ingredient_uid,
        "name": this.ingredient_name,
        "price": Math.abs(ingredient.price_static*(this.form.value.stock - this.old_stock)), //Siempre numero positivo
        "quantity": (this.form.value.stock - this.old_stock),
        "measurement": ingredient.measurement,
        "modifier": "",
      }],
      "uid": this.globals.restaurant_uid,
      "date": new Date(),
      "type": "stock",
      "comment": this.form.value.reason + "-" + this.globals.restaurant.name,
      "type_type": "MANUAL",
      "delivery_uid": null
    };
    this.analyticsService.sendStock(stock);
  }


}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-comp-create/ingredient-comp-create-stock/ingredient-comp-create-stock.ts